import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useSuperAdminCompanies() {
  return useQuery({
    queryKey: ["superadmin", "companies"],
    // El endpoint pagina ({count, results}); la página consume el array plano.
    queryFn: () =>
      apiClient
        .get("/api/v1/superadmin/companies/")
        .then((r) => r.data?.results ?? r.data),
  });
}

function useCreateCompany() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiClient.post("/api/v1/superadmin/companies/", data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["superadmin", "companies"] }),
  });
}

function useUpdateCompany() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) =>
      apiClient.patch(`/api/v1/superadmin/companies/${id}/`, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["superadmin", "companies"] }),
  });
}

export { useSuperAdminCompanies, useCreateCompany, useUpdateCompany };
